module.exports = __webpack_public_path__ + "assets/img/img-moc.svg";